import { useMemo } from "react";
import { useScheduleContext } from "../../context/useScheduleContext";
import { useEventMenu } from "./useEventMenu"
import { useDayCellMenu } from "./useDayCellMenu";
import { useUnassignedShiftsMenu } from "./useUnassignedShiftsMenu";
import { useResourceMenu } from "./useResourceMenu";
import { useCellMenu } from "./useCellMenu";
import { useOpenShiftMenu } from "./useOpenShiftMenu";

export const useContextMenuConfig = ({
    openActionsModal,
    openCopyModal,
    openDeleteModal,
    openAssignModal,
    openProfileSheet,
    openTransferModal,
    openShiftTradeDrawer,
    openClaimShiftDrawer,
    openSaveDayAsTemplate,
    openLoadTemplatesModal,
    openMoveToOpenShiftsModal,
}: any) => {
    const { type } = useScheduleContext();
    const eventMenu = useEventMenu({
        openActionsModal,
        openCopyModal,
        openDeleteModal,
        openTransferModal,
        openShiftTradeDrawer,
        openMoveToOpenShiftsModal
    });
    const dayCellMenu = useDayCellMenu({
        openActionsModal,
        openCopyModal,
        openDeleteModal,
        openSaveDayAsTemplate,
        openLoadTemplatesModal
    });
    const unassignedShiftsMenu = useUnassignedShiftsMenu({ openDeleteModal, openAssignModal });
    const resourceMenu = useResourceMenu({
        openProfileSheet,
        openCopyModal,
        openTransferModal,
        openActionsModal,
        openDeleteModal
    });
    const cellMenu = useCellMenu();
    const openShiftMenu = useOpenShiftMenu({ openClaimShiftDrawer });
    const isMyProfileTemplate = type === "my-profile";

    return useMemo(() => ({
        "event-menu": isMyProfileTemplate ? [] : eventMenu,
        "cell-menu": isMyProfileTemplate ? [] : cellMenu,
        "day-cell-menu": isMyProfileTemplate ? [] : dayCellMenu,
        "resource-menu": isMyProfileTemplate ? [] : resourceMenu,
        "unassigned-shifts-menu": isMyProfileTemplate ? [] : unassignedShiftsMenu,
        "open-shift-menu": isMyProfileTemplate ? [] : openShiftMenu
    }), [
        eventMenu,
        dayCellMenu,
        unassignedShiftsMenu,
        resourceMenu,
        cellMenu,
        openShiftMenu,
        isMyProfileTemplate
    ]);
}